export const logout = () => {
    return {
        type: "USER_LOGOUT",
        payload: {}
    }
}